import { useEffect, useState } from "react";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import axios from 'axios';
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import Select from 'react-select';
import { preferredDateFormatOptions } from '../../../../utils/generalSettingOption';
import { getLocations } from "../../../../services/location";
import { getTimeZones } from "../../../../services/Timezone";
import EmailValidatedComponent from "../../../../components/EmailValidatedComponent";
import { validateMin } from "../../../../utils/validateMin";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

export const AddBranch = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [isBranchOverview, setIsBranchOverview] = useState<boolean>(true);
  const [isFinancialSpecifications, setIsFinancialSpecifications] = useState<boolean>(true);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [isAdvancedBranchSettings, setIsAdvancedBranchSettings] = useState<boolean>(true);
  const [isTextSettings, setIsTextSettings] = useState<boolean>(false);
  const [isOnlineBookings, setIsOnlineBookings] = useState<boolean>(false);
  const [locations, setLocations] = useState<any[]>([]);
  const [defaultLocation, setDefaultLocation] = useState<string>("");
  const [branchName, setBranchName] = useState<string>("");
  const [websiteLink, setWebsiteLink] = useState<string>("");
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [prefixForReservation, setPrefixForReservation] = useState<string>("");
  const [supportedCurrencies, setSupportedCurrencies] = useState<string>("");
  const [locationFeeLabel, setLocationFeeLabel] = useState<string>("");
  const [locationFee, setLocationFee] = useState<string>("");
  const [taxLabel, setTaxLabel] = useState<string>("");
  const [tax, setTax] = useState<string>("");
  const [defaultFuelPricePerLiterOrGallon, setDefaultFuelPricePerLiterOrGallon] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [minHoursForDay, setMinHoursForDay] = useState<string>("");
  const [minAllowedHoursToBook, setMinAllowedHoursToBook] = useState<string>("");
  const [timeZone, setTimeZone] = useState('');
  const [preferredDateFormat, setPreferredDateFormat] = useState<string>("");
  const [timezoneOptions, setTimezoneOptions] = useState<any[]>([]);
  const [active, setActive] = useState<string>("Yes");

  useEffect(() => {
    getLocations(tenantId)
      .then(data => {
        setLocations(data.map((item: any) => {
          return {
            value: item.id,
            label: item.locationName,
          }
        }));
        handleTenantError(null);
      })
      .catch(error => {
        setLocations([]);
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getTimeZones(tenantId)
      .then(res => {
        const data = res?.map((item: any) => ({
          value: item?.id,
          label: item?.name
        }));
        setTimezoneOptions(data);
        handleTenantError(null);
      })
      .catch((error) => {
        setTimezoneOptions([]);
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangePhoneNumber = (value: string) => {
    const { length } = value;

    const regex = () => value.replace(/[^\d.]+/g, '');

    const areaCode = () => `(${regex().slice(0, 3)})`;

    const firstSix = () => `${areaCode()} ${regex().slice(3, 6)}`;

    const trailer = (start: number) => `${regex().slice(start, regex().length)}`;
    if (length < 3) {
      setPhoneNumber(regex());
    } else if (length >= 3 && length < 10) {
      setPhoneNumber(`${areaCode()} ${trailer(3)}`);
    } else if (length === 5) {
      setPhoneNumber(`${areaCode().replace(")", "")}`);
    } else if (length >= 10 && length < 15) {
      setPhoneNumber(`${firstSix()}-${trailer(6)}`);
    }
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setPleaseWaitPopup(true);
    e.preventDefault();

    await axios
      .post(
        `${baseURL}branch?userId=${auth?.id}`,
        JSON.stringify({
          branchName,
          websiteLink,
          emailAddress,
          prefixForReservation,
          supportedCurrencies,
          locationFeeLabel,
          locationFee,
          taxLabel,
          tax,
          defaultFuelPricePerLiterOrGallon,
          isImages: false,
          isActive: active === "Yes",
          isCalenderView: false,
          defaultLocationId: defaultLocation,
          governmentTax: 0,
          phoneNumber: phoneNumber,
          minHoursForDay: minHoursForDay,
          timeZone,
          minAllowedHoursToBook: minAllowedHoursToBook,
          preferredDateFormat
        }),
        {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
          withCredentials: true,
        }
      )
      .then(() => {
        setPleaseWaitPopup(false);
        navigate(-1);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  }


  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Branch</h2>
                </div>
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <h5
                    className="mb-0 flex items-center cursor-pointer select-none"
                    onClick={() => setIsBranchOverview(!isBranchOverview)}
                  >
                    {isBranchOverview ? (
                      <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    ) : (
                      <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    )}
                    <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                      Branch Overview
                    </div>
                  </h5>
                  <hr />

                  <div className="w-full px-2">
                    {isBranchOverview &&
                      <div className="grid grid-cols-3 gap-6">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Name</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={branchName}
                              onChange={(e) => setBranchName(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Email Address</label>
                            <EmailValidatedComponent
                              text={emailAddress}
                              setText={setEmailAddress}
                              required={true}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Phone Number</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={phoneNumber}
                              onChange={(e) => onChangePhoneNumber(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Minimum Allowed Hours To Book</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={minAllowedHoursToBook}
                              onChange={(e) => setMinAllowedHoursToBook(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                            <RadioGroup
                              row
                              value={active}
                              onChange={(e) => setActive(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes"
                                control=
                                {
                                  <Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />
                                }
                                label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel
                                value="No"
                                control={
                                  <Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />
                                }
                                label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Website Link</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={websiteLink}
                              onChange={(e) => setWebsiteLink(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Prefix for Reservation #</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={prefixForReservation}
                              onChange={(e) => setPrefixForReservation(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Minimum Hours For Day</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={minHoursForDay}
                              onChange={(e) => setMinHoursForDay(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Default Location</label>
                            <select
                              className={`w-full px-[8px] py-[10px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={defaultLocation}
                              onChange={(e) => setDefaultLocation(e.target.value)}
                            >
                              <option value={0}>None</option>
                              {
                                locations?.map((item: any) => {
                                  return (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  )
                                })
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-5 flex items-center cursor-pointer select-none"
                      onClick={() => setIsFinancialSpecifications(!isFinancialSpecifications)}
                    >
                      {isFinancialSpecifications ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Financial Specifications
                      </div>
                    </h5>
                    <hr />

                    {isFinancialSpecifications &&
                      <div className="grid grid-cols-3 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Supported Currencies</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={supportedCurrencies}
                              onChange={(e) => setSupportedCurrencies(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Location Fee (%)</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={locationFee}
                              onChange={(e) => setLocationFee(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Tax (%)</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={tax}
                              onChange={(e) => setTax(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Default Fuel Price Per Liter or Gallon</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={defaultFuelPricePerLiterOrGallon}
                              onChange={(e) => setDefaultFuelPricePerLiterOrGallon(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium invisible ${themeStyles.form.tailwindLabelTextColor}`}>Supported Currencies</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md invisible ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Location Fee Label</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={locationFeeLabel}
                              onChange={(e) => setLocationFeeLabel(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Tax Label</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={taxLabel}
                              onChange={(e) => setTaxLabel(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-5 flex items-center cursor-pointer select-none"
                      onClick={() => setIsAdvancedBranchSettings(!isAdvancedBranchSettings)}
                    >
                      {isAdvancedBranchSettings ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Advanced Branch Settings
                      </div>
                    </h5>
                    <hr />

                    {isAdvancedBranchSettings &&
                      <div className="grid grid-cols-3 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Preferred Date Format</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={false}
                              isRtl={false}
                              isSearchable={false}
                              name="preferredDateFormat"
                              value={preferredDateFormatOptions.find(
                                (item: any) => item?.value === parseInt(preferredDateFormat)
                              )}
                              onChange={(preferredDateFormat: any) =>
                                setPreferredDateFormat(preferredDateFormat ? preferredDateFormat?.value : "")
                              }
                              options={preferredDateFormatOptions}
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>TimeZone</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={false}
                              isRtl={false}
                              isSearchable={true}
                              name="preferredDateFormat"
                              required
                              value={timezoneOptions?.find(option => option?.value === parseInt(timeZone))}
                              options={timezoneOptions}
                              onChange={(selectedOption) => setTimeZone(selectedOption ? selectedOption?.value : '')}
                            />
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-5 flex items-center cursor-pointer select-none"
                      onClick={() => setIsTextSettings(!isTextSettings)}
                    >
                      {isTextSettings ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Text Settings
                      </div>
                    </h5>
                    <hr />

                    {isTextSettings &&
                      <div className={`${themeStyles.form.tailwindLabelTextColor}`}>Text Settings</div>
                    }

                    <h5
                      className="mb-0 mt-5 flex items-center cursor-pointer select-none"
                      onClick={() => setIsOnlineBookings(!isOnlineBookings)}
                    >
                      {isOnlineBookings ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Online Bookings
                      </div>
                    </h5>
                    <hr />

                    {isOnlineBookings &&
                      <div className={`${themeStyles.form.tailwindLabelTextColor}`}>Online Bookings</div>
                    }

                    {/* Buttons */}
                    <div className="flex gap-4 mt-6">
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="submit"
                      >
                        Save
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}